// frontend/src/services/coachHandbookApi.js
import api from "../config/api";

const coachHandbookApi = {
  getHandbook: async () => {
    const response = await api.get("/coach/handbook");
    return response.data;
  },

  getChapter: async (slug) => {
    const response = await api.get(`/coach/handbook/chapters/${slug}`);
    return response.data;
  },

  reload: async () => {
    const response = await api.post("/coach/handbook/_reload");
    return response.data;
  },
};

export default coachHandbookApi;
